import { useCallback, useState, useMemo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import debounce from 'lodash.debounce'
import { dispatch } from 'store'

export const useSelectedAudioVolumeUpdatesHandler = () => {
  const initialVolume = useSelector(projectDataSelectors.activeAudioVolume)

  const [volume, setVolume] = useState(initialVolume)

  const debounceChange = useMemo(
    () =>
      debounce((value: number) => {
        dispatch(projectDataThunks.updateActiveAudioVolume(value))
      }, 400),
    []
  )

  const onChangeVolume = useCallback(
    (newValue: number) => {
      setVolume(newValue)
      debounceChange(newValue)
    },
    [debounceChange]
  )

  useEffect(() => {
    setVolume(initialVolume)
  }, [initialVolume])

  return {
    onChangeVolume,
    volume
  }
}
